export interface HasExternalPays {
    hasExternalPays?: boolean;
    hasExternalPaysAutomatic?: boolean;
    PublicServicesAutomaticCategory: configCategory;
    PublicServicesCategory: configCategory;
    publicServices: configPay;
    cardTerminal: configPay;
}

interface configPay {
    enable : boolean;
    name: string;
    img: string[];
    sku: string;
}
interface configCategory{
  nameCategory: string;
  idCategory: string;
}

export const CATALOGUE_HAS_PUBLIC_SERVICES: HasExternalPays = {
    
  PublicServicesAutomaticCategory: {
    "nameCategory": "Pago Facturas",
    "idCategory": "paymentServicesAutomatic"
  },
  PublicServicesCategory: {
    "nameCategory": "Pointz",
    "idCategory": "paymentServices"
  },
    publicServices : {
        enable : true,
        name : 'Pagos de servicios públicos y/o privados',
        img : ['../../../../assets/img/thumbnail5.png'],
        sku : 'PaymentServicesSKU'
      },
      cardTerminal : {
        enable : false,
        name : 'Pagos en el punto de venta',
        img : ['../../../../assets/img/thumbnail6.png'],
        sku : 'cardTerminalSKU'
      }
}